import { icons } from '@shared/static/icons';
import { binsLogo, MASTER_BANK_ID } from '@utils/static';
import { CountryFlag } from '@shared/ui/parts';
import { formatBalanceUi } from '@utils/balance-helpers';
import { ALL_BANKS } from '@utils/tables/params';

function getBankIcon(bankId) {
  if (bankId === ALL_BANKS) return icons.any;
  if (bankId === MASTER_BANK_ID) return icons['Master balance'];
  return <CountryFlag countryCode={binsLogo[bankId]} />;
}

export default function RenderItemBalance({ item }) {
  return (
    <div className="select-balance">
      <div className="select-balance-left">
        {getBankIcon(item?.bank_id)}
        <p>{item?.bank_public_name}</p>
      </div>
      <p className="secondary-text">
        {formatBalanceUi(item?.balance, item?.currency)}
      </p>
    </div>
  );
}
